<div class="ltms-feed-detail-panel" [class.show]="visible">
  <div class="ltms-feed-detail-container">
    <div class="ltms-feed-detail-header">
      <div class="left-panel">
        <div class="left-panel-label">Select Channels</div>
      </div>
      <div class="right-panel">
        <button type="button" class="panel-icon-btn" (click)="openRequestDetails($event)"
          title="View request details" [disabled]="isSending">
          <img src="assets/images/info-icon.svg" alt="Request details">
        </button>
        <button type="button" (click)="closePanel()" title="Close" [disabled]="isSending">
          <img src="assets/images/close.svg" alt="Close">
        </button>
      </div>
    </div>

    <div class="ltms-feed-detail-body">
      <div class="channel-selection-loader" *ngIf="isLoading">
        <app-ltms-loader></app-ltms-loader>
      </div>

      <div class="channel-selection-content" *ngIf="!isLoading">
        <p class="channel-selection-help">
          On-demand trials run in sequence. Send is available only for the next eligible trial.
        </p>

        <div class="channel-request-deadline"
          *ngIf="showDeadlineBlock"
          [class.is-expired]="isDeadlineExpired">
          <div class="channel-request-deadline-main">
            <ng-container *ngIf="!showDeadlineAsDate; else absoluteDeadline">
              <span class="channel-request-deadline-label">Request Deadline</span>
              <span class="channel-request-deadline-value" aria-live="polite">{{ liveDeadlineLabel }}</span>
            </ng-container>
            <ng-template #absoluteDeadline>
              <span class="channel-request-deadline-label">{{ isDeadlineExpired ? 'Expired on' : 'Expires on' }}</span>
              <span class="channel-request-deadline-value">{{ requestDeadlineAbsolute }}</span>
            </ng-template>
          </div>
          <button type="button"
            class="channel-request-deadline-toggle"
            *ngIf="requestDeadlineAbsolute"
            (click)="toggleDeadlineDisplay($event)">
            {{ showDeadlineAsDate ? 'Show timer' : 'Show date' }}
          </button>
        </div>

        <div class="channel-tag-context" *ngIf="tagSearchContext">
          <div class="channel-tag-context-label">{{ tagSearchContext.label }}</div>
          <p class="channel-tag-context-note">
            Select trial's channels for
            <span class="channel-tag-context-field">{{ tagSearchContext.label }}</span>
            <span class="channel-tag-context-value">{{ tagSearchContext.value }}</span>
          </p>
        </div>

        <div class="channel-status-legend" aria-label="Channel status legend">
          <span class="legend-item">
            <span class="legend-swatch sent" aria-hidden="true"></span>
            Sent
          </span>
          <span class="legend-item">
            <span class="legend-swatch delivered" aria-hidden="true"></span>
            Delivered
          </span>
          <span class="legend-item">
            <span class="legend-swatch not-selected" aria-hidden="true"></span>
            Not selected
          </span>
        </div>

        <ol class="trial-timeline" *ngIf="trialSections.length">
          <li class="trial-section"
            *ngFor="let section of trialSections; let last = last"
            [class.enabled]="section.enabled"
            [class.disabled]="!section.enabled"
            [class.completed]="section.completed"
            [class.expanded]="section.expanded">
            <div class="trial-rail" aria-hidden="true">
              <div class="trial-dot">
                <span class="trial-dot-check" *ngIf="section.completed">✓</span>
              </div>
              <div class="trial-line" *ngIf="!last"></div>
            </div>

            <div class="trial-card">
              <button type="button"
                class="trial-card-header"
                [attr.aria-expanded]="section.expanded"
                [attr.aria-controls]="'trial-content-' + section.trialNumber"
                (click)="toggleTrialExpanded(section, $event)">
                <div class="trial-heading">
                  <div class="trial-title">{{ section.title }}</div>
                  <div class="trial-sent-date" *ngIf="section.completed && section.sentDate">
                    Sent on {{ section.sentDate }}
                  </div>
                  <div class="trial-sent-date" *ngIf="section.completed && section.managerEmail">
                    Sent by {{ section.managerEmail }}
                  </div>
                </div>
                <div class="trial-header-right">
                  <div class="trial-status" *ngIf="section.completed">Sent</div>
                  <div class="trial-status pending" *ngIf="section.enabled">Active</div>
                  <div class="trial-status locked" *ngIf="!section.enabled && !section.completed">Locked</div>
                  <img class="trial-chevron"
                    [class.expanded]="section.expanded"
                    [src]="section.expanded ? 'assets/images/chevron-up.svg' : 'assets/images/chevron-down.svg'"
                    alt="" />
                </div>
              </button>

              <div class="trial-card-body"
                *ngIf="section.expanded"
                [id]="'trial-content-' + section.trialNumber">
                <div class="channel-row" *ngIf="section.channels.length">
                  <div class="channel-row-label">Channels</div>
                  <div class="channel-chips">
                    <!-- Active trial: selectable chips (no All option) -->
                    <ng-container *ngIf="!section.completed">
                      <label class="channel-chip"
                        *ngFor="let option of section.channels"
                        [class.selected]="option.selected"
                        [class.disabled-label]="!section.enabled || isSending || isDeadlineExpired">
                        <input type="checkbox"
                          [(ngModel)]="option.selected"
                          [disabled]="!section.enabled || isSending || isDeadlineExpired"
                          (ngModelChange)="onToggleChannel(section)" />
                        <span class="channel-chip-mark" aria-hidden="true">✓</span>
                        <span class="channel-chip-text">{{ option.label }}</span>
                      </label>
                    </ng-container>

                    <!-- Sent trial: status chips only (no selection ticks) -->
                    <ng-container *ngIf="section.completed">
                      <span class="channel-chip status-chip"
                        *ngFor="let option of section.channels"
                        [class.status-sent]="option.status === 'sent'"
                        [class.status-delivered]="option.status === 'delivered'"
                        [class.status-not-selected]="option.status === 'not_selected'"
                        [attr.title]="option.status === 'not_selected'
                          ? (option.label + ' was not selected')
                          : (option.label + ' — ' + option.status)">
                        <span class="channel-chip-text">{{ option.label }}</span>
                        <span class="channel-chip-hint"
                          *ngIf="option.status === 'not_selected'">Skipped</span>
                      </span>
                    </ng-container>
                  </div>
                </div>

                <div class="channel-empty" *ngIf="!section.channels.length">
                  No channels configured for this trial.
                </div>

                <div class="trial-actions" *ngIf="section.enabled">
                  <button type="button"
                    class="action-send-btn"
                    (click)="sendTrial(section)"
                    [disabled]="!canSendTrial(section)">
                    <span class="btn-loader" *ngIf="isSending && section.enabled"></span>
                    <span class="action-btn-label" *ngIf="!(isSending && section.enabled)">Send</span>
                  </button>
                </div>
              </div>
            </div>
          </li>
        </ol>

        <div class="channel-empty" *ngIf="!trialSections.length">
          No on-demand trials are configured for this project.
        </div>
      </div>
    </div>

    <div class="ltms-feed-detail-footer">
      <button type="button" class="action-cancel-btn" (click)="closePanel()" [disabled]="isSending">
        Cancel
      </button>
    </div>
  </div>
</div>
